(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('LotImportDialogController', LotImportDialogController);

    LotImportDialogController.$inject = [ '$scope', '$stateParams', '$q', 'Contract', 'AlertService', 'LotCustomService', 'ToastrService', 'ContractCustomService', 'ShipmentCustomService' ];

    function LotImportDialogController( $scope, $tateParams, $q, Contract, AlertService, LotCustomService, ToastrService, ContractCustomService, ShipmentCustomService ) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.contracts = [];
        vm.saleContracts = [];
        vm.lots = [];
        vm.lotStatuses = ['AVAILABLE','ALLOCATED'];
        vm.qtyUnitTypes = ['BALES','MTS'];
        vm.wtUnitTypes = ['KG', 'LB', 'MT'];
        vm.wtUnitType = vm.wtUnitTypes[0];
        vm.separators = ['Point', 'Comma'];
        vm.separator = vm.separators[0];

        vm.lotStatus = "AVAILABLE";
        vm.purchaseContract = null;
        vm.saleContract = null;
        vm.growth = null;
        vm.seller = null;
        vm.loadingPeriod = null;
        vm.loadingPlace = null;
        vm.loadingWarehouse = null;
        vm.cropYear = null;
        vm.purchPriceUnit = null;
        vm.purchPrice = 0;
        vm.purchWtType = null;
        vm.lotWeightDisplay = null;

        vm.showPContractDetails = false;
        vm.showPurchSiInput = false;
        vm.showPurchSiDetails = false;
        vm.purchSi = null;
        vm.allocSi = null;
        vm.purchaseSiList = [];

        vm.openCalendar = openCalendar;
        vm.save = save;

        fetchContracts();

        function fetchContracts() {
            Contract.query({
                type: 'PURCHASE',
                sort: sort()
            }, onSuccess, onError );
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.contracts.length = 0;
            for (var i = 0; i < data.length; i++) {
                vm.contracts.push(data[i]);
            }
        }

        function onError(error) {
            console.log( "error" );
            AlertService.error(error.data.message);
        }

        function save() {
            vm.hot.data.forEach( function( element) {
                if( Object.keys( element ).length == 13 ) {
                    buildLot( element );
                }
            });
            vm.isSaving = true;
            LotCustomService.saveImportLots( vm.lots, vm.purchaseContract.id ).then( function( data ) {
                ToastrService.success( "Successfully imported Lots", "Success!" );
                vm.isSaving = false;
            }, function( error ) {
                if( error.status !== "404" ) {
                    ToastrService.error( error.message, "Error!" );
                }
                console.log( error.message );
                vm.isSaving = false;
            });
        }

        //===============================================
        //Purchase Contract Details Tab
        //===============================================
        vm.datePickerOpenStatus.date = false;

        vm.activateLotStatus = activateLotStatus;
        vm.applyPurchaseContractStuff = applyPurchaseContractStuff;
        vm.fetchShipments = fetchShipments;
        vm.clearShipment = clearShipment;
        vm.applyPurchSiDetails = applyPurchSiDetails;

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        function activateLotStatus( option ) {
            if( vm.saleContract !== null && vm.saleContract !== undefined ) {
                vm.lotStatus == "ALLOCATED";
            } else {
                vm.lotStatus == "AVAILABLE";
            }
        }

        vm.activateQtyUnitType = function( option ) {
            // vm.qtyUnitType = option;
        };

        function applyPurchaseContractStuff() {
            if( vm.purchaseContract !== null ) {
                vm.showPContractDetails = true;
                vm.cropYear = vm.purchaseContract.cropYear;
                vm.seller = vm.purchaseContract.seller.name;
                vm.growth = vm.purchaseContract.growth.location;
                vm.qtyUnitType = vm.purchaseContract.qtyUnitType;
                fetchShipments();
            }
        }

        function fetchShipments() {
            if( vm.purchaseContract !== null && vm.purchaseContract !== undefined ) {
                ShipmentCustomService.returnShipmentsByPurchContractAndSaleContract( vm.purchaseContract.id, null ).then( function( data ) {
                    vm.purchaseSiList.length = 0;
                    vm.purchaseSiList = data.data;
                    if( vm.purchaseSiList.length > 0 ) {
                        // ToastrService.success( "Grabbed Shipments Success", "Success!");
                    } else {
                        ToastrService.warning( "No applicable shipments for selected Purchase Contract");
                    }
                }, function( error ) {
                    if( error.status !== "404" ) {
                        ToastrService.error( "Something went wrong" );
                    }
                    console.log( error.message );
                });
            } else {
                ToastrService.info( "Please select a Purchase Contract");
            }
        }

        function clearShipment() {
            vm.purchSi = null;
            vm.showPurchSiDetails = false;
            applyPurchSiDetails();
        }

        function applyPurchSiDetails() {
            if( vm.purchSi !== null && vm.purchSi !== undefined ) {
                ContractCustomService.returnSaleContractByShipment( vm.purchSi.id ).then( function( data ) {
                    vm.saleContract = data.data;
                    vm.allocSi = vm.purchSi;
                    vm.lotStatus = "ALLOCATED";
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Cannot fetch Sale Contract of selected shipment", "Error" );
                    }
                    console.log( error.statusText );
                    vm.saleContract = null;
                    vm.allocSi = null;
                });
                vm.showPurchSiDetails = true;
            } else {
                vm.lotStatus = "AVAILABLE";
                vm.saleContract = null;
                vm.allocSi = null;
                vm.showPurchSiDetails = false;
            }
        };

        //===============================================
        //Lots To Import Tab
        //===============================================
        vm.activateWtUnitType = activateWtUnitType;
        vm.activateSeparator = activateSeparator;

        function activateWtUnitType( option ) {
            vm.wtUnitType = option;
        };

        function activateSeparator( option ) {
            vm.separator = option;
        }

        vm.hot = {
            settings: { colHeaders: true, contextMenu: ['row_above', 'row_below', 'remove_row']},
            rowHeaders: true,
            minSpareRows: 1,
            data: []
        };

        function resolveWeightDisplay( weight ) {
            return weight + " " + vm.wtUnitType;
        }

        function resolveWeights( weight, lot ) {
            var newWeight = periodsOrCommas( weight );
            var lbs = 0;
            var kgs = 0;
            var mts = 0;
            var avg = Math.round( ( newWeight / lot.qtyBales ) * 100 ) / 100;
            switch( vm.wtUnitType ) {
                case 'LB':
                    lbs = newWeight;
                    kgs = Math.round( ( newWeight / 2.2046 ) * 100 ) / 100;
                    mts = Math.round( ( kgs / 1000 ) * 100 ) / 100;
                    break;
                case 'KG':
                    kgs = newWeight;
                    lbs = Math.round( ( kgs * 2.2046 ) * 100 ) / 100;
                    mts = Math.round( ( kgs / 1000 ) * 100 ) / 100;
                    break;
                case 'MT':
                    mts = newWeight;
                    kgs = Math.round( ( mts * 1000 ) * 100 ) / 100;
                    lbs = Math.round( ( kgs * 2.2046 ) * 100 ) / 100;
                    break;
            }
            lot['lotWeightLbs'] = lbs;
            lot['lotWeightKgs'] = kgs;
            lot['lotWeightMts'] = mts;
            //actual weights
            lot['purchGrossLbs'] = lbs;
            lot['purchNetLbs'] = lbs;
            lot['purchTareLbs'] = 0;
            lot['purchGrossKgs'] = kgs;
            lot['purchNetKgs'] = kgs;
            lot['purchTareKgs'] = 0;
            lot['purchGrossMTs'] = mts;
            lot['purchNetMTs'] = mts;
            lot['purchTareMTs'] = 0;
            //landed weights
            lot['purchLandedGrossLbs'] = lbs;
            lot['purchLandedNetLbs'] = lbs;
            lot['purchLandedTareLbs'] = 0;
            lot['purchLandedGrossKgs'] = kgs;
            lot['purchLandedNetKgs'] = kgs;
            lot['purchLandedTareKgs'] = 0;
            lot['purchLandedGrossMTs'] = mts;
            lot['purchLandedNetMTs'] = mts;
            lot['purchLandedTareMTs'] = 0;
            //avg weights
            lot['actualWtAvg'] = avg;
            lot['actualWtGrossAvg'] = avg;
            lot['actualWtTareAvg'] = 0;
            lot['landedWtAvg'] = avg;
            lot['landedWtGrossAvg'] = avg;
            lot['landedWtTareAvg'] = 0;
            return lot;
        }

        function periodsOrCommas( myWeight ) {
            if( vm.separator === "Point" ) {
                return mathRoundIgnoreCommas( myWeight );
            } else {
                return mathRoundConvertCommasToDecimal( myWeight );
            }
        }

        function mathRoundIgnoreCommas( myWeight ) {
            var numberNoCommas = myWeight.replace(/,/g, '');
            return Math.round( numberNoCommas * 100 ) / 100;
        }

        function mathRoundConvertCommasToDecimal( myWeight ) {
            var numberConvertCommas = myWeight.replace(/,/g, '.');
            return Math.round( numberConvertCommas * 1000 ) / 1000;
        }

        function buildLot( element ) {
            var lot = {
                //given values
                id: null,
                createdOn: new Date(),
                createdBy: "user",
                modifiedOn: new Date(),
                modifiedBy: "user",
                lotStatus: vm.lotStatus,
                qtyUnitType: vm.qtyUnitType,
                purchase: vm.purchaseContract,
                purchPriceUnit: vm.purchPriceUnit,
                purchPrice: vm.purchPrice,
                purchWtType: vm.wtUnitType,
                purchSi: vm.purchSi,
                allocSale: vm.saleContract,
                allocSi: vm.allocSi,
                cropYear: vm.cropYear,
                growth: vm.growth,
                loadingPeriod: vm.loadingPeriod,
                loadingPlace: vm.loadingPlace,
                loadingWarehouse: vm.loadingWarehouse,
                takeUpNr: vm.takeUpNr,
                loadingDate: vm.date,
                seller: vm.seller,
                placeOfTakeUp: vm.placeOfTakeUp,
                ginRef: element.ginRef,
                origin: element.origin,
                producer: element.producer,
                lotRef: element.lotRef,
                qtyBales: element.qtyBales,
                lotType: element.lotType,
                lotWeightDisplay: resolveWeightDisplay( element.lotWeightDisplay ),
                lotMic: element.lotMic,
                lotLen: element.lotLen,
                lotStr: element.lotStr,
                lotRdb: element.lotRdb,
                lotSfi: element.lotSfi,
                farmRef: element.farmRef,
                imported: true,
                //default purch stuff values
                purchValue: 0,
                //default inter stuff values
                interPrice: 0,
                interGrossKgs: 0,
                interNetKgs: 0,
                interTareKgs: 0,
                interGrossLbs: 0,
                interNetLbs: 0,
                interTareLbs: 0,
                interGrossMTs: 0,
                interNetMTs: 0,
                interTareMTs: 0,
                interLandedGrossKgs: 0,
                interLandedNetKgs: 0,
                interLandedTareKgs: 0,
                interLandedGrossLbs: 0,
                interLandedNetLbs: 0,
                interLandedTareLbs: 0,
                interLandedGrossMTs: 0,
                interLandedNetMTs: 0,
                interLandedTareMTs: 0,
                interValue: 0,
                //default sale stuff values
                salePriceUnit: null,
                salePrice: 0,
                saleFinalPrice: 0,
                saleWtType: null,
                saleGrossKgs: 0,
                saleNetKgs: 0,
                saleTareKgs: 0,
                saleGrossLbs: 0,
                saleNetLbs: 0,
                saleTareLbs: 0,
                saleGrossMTs: 0,
                saleNetMTs: 0,
                saleTareMTs: 0,
                saleLandedGrossKgs: 0,
                saleLandedNetKgs: 0,
                saleLandedTareKgs: 0,
                saleLandedGrossLbs: 0,
                saleLandedNetLbs: 0,
                saleLandedTareLbs: 0,
                saleLandedGrossMTs: 0,
                saleLandedNetMTs: 0,
                saleLandedTareMTs: 0,
                saleValue: 0,
                landedValue: 0,
                invoiceValue: 0
            }
            vm.lots.push( resolveWeights( element.lotWeightDisplay, lot ) );
        }

    }
})();
